import React from 'react'
import { genericGet, genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../Constants";
import { useEffect, useState,useRef } from "react";
import { useHistory } from "react-router-dom";
import * as Survey from "survey-react";
import cogoToast from "cogo-toast";
import { LoadingOverlay, Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { useReactToPrint } from 'react-to-print';
 
import QRCode from "react-qr-code";

const AddPrescriptions = (props) => {
  const history = useHistory();
  const { patient_info, room } = (props.location && props.location.state) || {};
  const [template, setTemplate] = useState(null)
  const [prescriptions, setPrescriptions] = useState(null)

  const componentRef = useRef();

  const [loading, setLoading] = useState(false)
  const [prescribed_items, setprescribed_items] = useState(null)



  const [voucher, setvoucher] = useState()
useEffect(() => {
    // Check if patient_info exists, if not redirect to HMIS dashboard
    if (!patient_info || !patient_info.visit_id) {
      cogoToast.error("Patient information is required. Please select a patient first.", {
        hideAfter: 5,
      });
      history.push("/hmis/dashboard");
      return;
    }
    
    fetch_template();
    list_prescriptions(patient_info.visit_id)
    return () => {};
  }, []);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const fetch_template = (_status) => {
     
    setLoading(true)
    genericGet(ENDPOINTS.GET_PRESCRIPTION_TEMPLATE )
    .then((res) => {
        
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
                setTemplate(null);
             
                setTemplate(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        
        cogoToast.error(err, {});

        console.log(err);
    });
   
  };
  


  const delete_prescription = (service_request_id) => {
     if (!window.confirm("Are you sure to delete this Prescription? "))
      return
    setLoading(true)
    genericPost(ENDPOINTS.DELETE_PRESCRIPTION,{"service_request_id":service_request_id} )
    .then((res) => {
        setLoading(false)
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                if (patient_info && patient_info.visit_id) {
                  list_prescriptions(patient_info.visit_id)
                }
                cogoToast.success(res.data.message, {});

            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setLoading(false)
        cogoToast.error(err, {});

        console.log(err);
    });
   
  };

  const list_prescriptions = (visit_id) => {
     
    setLoading(true)
    genericPost(ENDPOINTS.LIST_PRESCRIPTION,{"visit_id":visit_id} )
    .then((res) => {
        setLoading(false)
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
                setPrescriptions(null);
             
                setPrescriptions(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setLoading(false)
        cogoToast.error(err, {});

        console.log(err);
    });
   
  };
  


  const _submit = (form_result) => {
    console.log(form_result.valuesHash);

    // Validate required data before submitting
    if (!patient_info || !patient_info.visit_id) {
      cogoToast.error("Patient information is missing. Please select a patient first.", {
        hideAfter: 5,
      });
      history.push("/hmis/dashboard");
      return;
    }

    if (!room || !room.room_id) {
      cogoToast.error("Room information is missing. Please select a room first.", {
        hideAfter: 5,
      });
      history.push("/hmis/consultation-rooms");
      return;
    }

    let payload = {
      visit_id: patient_info.visit_id,
      from_room_id: room.room_id,
      room_id: "5329d1fe-81f1-11ec-81e5-0a9ea65235cc",
      prescription_request:   form_result.valuesHash ,
     
    };

    
    setLoading(true)
    
    genericPost(ENDPOINTS.ADD_PRESCRIPTION,payload )
    .then((res) => {
    

        // setIsLoading(false);
        if (res.status == 200) {

            if (res.data.status == SUCCESS_RESULT) {
              setLoading(false)
                let responseData = res.data.data;
           

   
setprescribed_items(responseData?.prescriptions[0]?.prescribed_items);

                cogoToast.success(res.data.message, {});
                setvoucher(responseData?.prescriptions[0]);
               

    if (patient_info && patient_info.visit_id) {
      list_prescriptions(patient_info.visit_id)
    }

            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        // setIsLoading(false);
        setLoading(false)
        cogoToast.error(err, {});

        console.log(err);
    });
  };


    // Show error message if patient_info is missing
    if (!patient_info || !patient_info.visit_id) {
      return (
        <div className="alert alert-danger" role="alert">
          <h4>Missing Patient Information</h4>
          <p>Patient information is required to add prescriptions. Please select a patient first.</p>
          <button 
            className="btn btn-primary" 
            onClick={() => history.push("/hmis/dashboard")}
          >
            Go to HMIS Dashboard
          </button>
        </div>
      );
    }

    return (
        <div className='row'> 

        <div className='col-md-7'>

        
        <Loader loading={loading}/>
         <h1 className="alert alert-primary">
           Prescriptions ➤   {patient_info?.name || 'Unknown Patient'}  
            </h1>
       
        {template != null  && !prescribed_items && (
        <Survey.Survey json={template}
        
        onCompleting={(survey, options) => {
            options.allowComplete = false;
            survey.clear(false, true);
   
    _submit(survey);
     
            
          }}


        
        
     />
      )}
 
{prescribed_items !=null && <>

 










    <button
            type="button"
            className="btn btn-default"
            onClick={handlePrint}
            
          >
           
            Print
          </button>
&nbsp;
&nbsp;
&nbsp;
          <button
            type="button"
            className="btn btn-secondary"
            onClick={()=>{
              setvoucher(null)
              setprescribed_items(null)
            }}
            
          >
           
            Close
          </button>



 <div         className="visitPrint   white-bg"
        style={{ width: "950px", margin: "auto" }}>
<div
      style={{ width: "650px", margin: "auto" }}
        ref={componentRef}
      >
      <br/> <br/>
      <center><h1>

         {voucher?.hospital?.name.toString()} 
</h1>
 
<h1> ISLAMIC RELIEF - SOMALIA</h1>

<h1>{voucher?.health_facility}</h1>
<h3> PRESCRIPTION LETTER</h3>
 
  <table>

  <tr>
<td><h3>Name : {patient_info?.name.toString()} </h3> </td>
</tr>
<tr>
<td> <h3>Voucher No : <b>{voucher?.voucher.toString()} </b> </h3> </td>
<td rowSpan={2}> 
  <QRCode style={{width:"80px",height:"80px",marginTop:"-18px",marginLeft:"100px"}}   value={""+voucher?.voucher.toString()+""} ></QRCode> 
  </td>

  </tr>
<tr>
  <td>
    Prescription Date : {voucher?.created_at.toString().replaceAll("T"," ").replaceAll(".000000Z"," ").toString()}
  </td>
 
</tr>
<tr>
{/* <td>
    Visit Number : {voucher?.visit_number.toString()}
  </td> */}
</tr>
</table>
<br/>  





</center>

<table className="info_table">
<thead>
  <th>No.</th>
  <th>Drug</th>
  <th>Mode of application</th>
  <th>Remarks</th>
 
</thead>
<tbody>
  
  {prescribed_items?.map((p,i)=>{
return  <tr>

  <td>{i+1}</td> <td><b>{p?.drug.toString()}</b></td> <td>{p?.mode_of_application.toString()}</td><td>{p?.remarks.toString()}</td> 
 
</tr> 
  })}
 
  
</tbody>
<tfoot>
    <tr>
        <td colSpan={4}>Doctor's Signature ({voucher?.doctor.toString()}) : __________________</td>
    </tr>
</tfoot>
 </table>
 
         </div>
         </div>
</>}
</div>
<div className='col-md-5'>
  <div className='card'>
    <div className='card-body'>

    
          <h3>Previous Prescriptions</h3>

          {/* {JSON.stringify(prescriptions)} */}

          <table className='info_table' >
            <thead>
              <th>Date</th>
              <th>Visit number</th>
              <th>voucher number</th>
              <th>Doctor</th>

              <th>..</th>
              <th>..</th>

            </thead>
            {
              prescriptions?.map((p)=>{
                return <tr>
                  <td>{p?.created_at.toString().replaceAll("T"," ").replaceAll(".000000Z"," ")}</td>
                  <td>{p.visit_number}</td>
                  <td>{p.voucher}</td>
                  <td>{p.doctor}</td>
                  <td>
                    <button className='btn btn-primary' onClick={()=>{
                              setvoucher(p);
                      setprescribed_items(p.prescribed_items);
              
                    
                    }
                      
                      
                      } >
                      Open
                    </button>
                  </td>
                  <td>
                    <button className='btn btn-primary' onClick={()=>{
                               delete_prescription(p.id);
                                      }
                                      } >
                      Delete
                    </button>
                  </td>
                </tr>
              })
            }
          </table>
          </div>
  </div>
        </div>
     </div>
    )
}

export default AddPrescriptions
